export default {
  publicPreferenceCenterGet: jest.fn(),
  publicPreferenceCenterPost: jest.fn(),
  publicPreferenceCenterCheckboxesGet: jest.fn(),
  publicPreferenceCenterCheckboxesPost: jest.fn(),
};
